import React, { useEffect, useState } from 'react';

import styles from './DogCardLeashTests.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import { general } from '../../../../../../general';
import BarGraphCard from '../../../../Statistics/Cards/BarGraphCard/BarGraphCard';

function DogCardLeashTests(props: DogCardLeashTestsProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();

    const [openTest, setOpenTest] = useState<string>("");
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/leash/tests",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        getData();
    }, [props.dogId]);

    return (
        <div className={styles.statisticsleashtests}>
            <Card
                title={t("dog.statistics.leashtests.title")}
                children={<div>
                    {data?.map((item: any) => {
                        let date = new Date(item["TEST_DATE"]);
                        let year = date.getFullYear();

                        // Day padded with 0
                        let day = ("0" + date.getDate()).slice(-2);

                        // Month padded with 0
                        let month = ("0" + (date.getMonth() + 1)).slice(-2);

                        return <div
                            key={item["ID"]}
                            className={styles.test}
                        >
                            <div
                                className={styles.testheader}
                                onClick={() => setOpenTest(openTest == item["ID"] ? "" : item["ID"])}
                            >
                                <div className={styles.testdate}>
                                    <span>{day}.{month}</span>
                                    <span>{year}</span>
                                </div>
                                <div className={styles.testname}>
                                    <span>{item["TEST_ID"]}</span>
                                    <span>{item["ORGANIZER_NAME"]}</span>
                                    {/*<span>{item["TERRENG"]}{ item["TERRENG"] && item["KOMMUNE"] ? ", " : "" }{item["KOMMUNE"]}</span>*/}
                                </div>
                                <div className={styles.testresult}>
                                    <span>
                                        {item["PRIZE"] != 0 ?
                                            t("dog.statistics.leashtests.results.prize") + ": " + item["PRIZE"] + ". " + t("dog.statistics.leashtests.results.place")
                                        : <strong>&nbsp;</strong>}
                                    </span>
                                    <span>
                                        {t("dog.statistics.leashtests.results.points")}: {item["POINTS"]}
                                    </span>
                                </div>
                            </div>
                            <div className={styles.testcontent} style={{ display: openTest == item["ID"] ? "block" : "none" }}>
                                <BarGraphCard
                                    title=''
                                    data={{
                                        labels: [
                                            "M1",
                                            "M2",
                                            "M3",
                                            "M4",
                                            "M5",
                                        ],
                                        datasets: [
                                            {
                                                label: t("dog.statistics.leashtests.results.title"),
                                                data: [
                                                    item["M1"],
                                                    item["M2"],
                                                    item["M3"],
                                                    item["M4"],
                                                    item["M5"],
                                                ],
                                                backgroundColor: "#68db5a",
                                            }
                                        ]
                                    }}
                                    options={{
                                        plugins: {
                                            legend: {
                                                display: true
                                            }
                                        },
                                        scales: {
                                            y: {
                                                suggestedMax: 10,
                                                suggestedMin: 0,
                                                beginAtZero: true
                                            }
                                        }
                                    }}
                                ></BarGraphCard>
                                <p>
                                    <strong>{t("dog.statistics.leashtests.results.comment")}</strong>
                                </p>
                                <p>
                                    {item["KONKLUSJON"]}
                                </p>
                                { item["PDF_URL"] ?
                                    <p><a href={"https://www.dogweb.no/" + item["PDF_URL"]} target="_blank" rel="noreferrer">PDF (Dogweb)</a></p>
                                : ""}
                            </div>
                        </div>;
                    })}
                </div>}
            />
        </div>
    );
}

class DogCardLeashTestsProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardLeashTests;